import createReducer from 'store/create-reducer';
import {
  SET_CONNECTION, SET_RECOMMENDATIONS, SET_CONNECTIONS_REQUESTED, ADD_REQUESTED_CONNECTION,
  NOTIFICATION_TO_ROOM, NOTIFICATION, SET_HAS_PENDING_REQUESTS,
} from 'store/globalState/action-types';
import * as NOTIFICATIONS from 'constants/notifications';
import { loadingAction } from 'store/globalState/global';
import apiFetch from 'utils/apiFetch';
import _ from 'lodash';

const filterConnections = (array, userChats, allConnections) => {
  const newArray = [];
  array.map((connection) => {
    if (typeof newArray.find(c => c.id === connection.id) === 'undefined') {
      newArray.push(connection);
    }
    return connection;
  });

  if (allConnections) {
    return newArray;
  }
  const newArray2 = [];
  newArray.forEach((connection) => {
    let found = false;
    let i = 0;
    while (!found && i < userChats.length) {
      if (_.isEmpty(userChats[i].element_related)) {
        if (userChats[i].users.some(elem => elem.id === connection.id) || newArray2.some(elem2 => elem2.id === connection.id)) {
          found = true;
        }
      }
      i += 1;
    }

    if (!found) {
      newArray2.push(connection);
    }
  });
  return newArray2;
};

export const getUserConnect = allConnections => (dispatch, getState) => {
  const { session: { user: { id } }, chats: { chats: userChats } } = getState();
  apiFetch(
    'GET',
    { endPoint: 'users/connection' },
    { user: id },
  ).then((res) => {
    const connections = filterConnections(res, userChats, allConnections);
    dispatch({ type: SET_CONNECTION, connections });
  });
};

export const getUserRecommendations = () => (dispatch) => {
  dispatch(loadingAction(true));
  apiFetch(
    'GET',
    { endPoint: 'users/recommendations' },
  ).then((recommendations) => {
    dispatch({ type: SET_RECOMMENDATIONS, recommendations });
    dispatch(loadingAction(false));
  }).catch(() => {
    dispatch(loadingAction(false));
  });
};

export const getUserRequestedConnections = () => (dispatch) => {
  dispatch(loadingAction(true));
  apiFetch(
    'GET',
    { endPoint: 'users/connection/requested' },
  ).then((requested) => {
    dispatch({ type: SET_CONNECTIONS_REQUESTED, requested });
    dispatch(loadingAction(false));
  }).catch(() => {
    dispatch(loadingAction(false));
  });
};

export const addRequestedConnection = user => (dispatch) => {
  dispatch({ type: ADD_REQUESTED_CONNECTION, user });
};

export const removeConnection = id => (dispatch, getState) => {
  const { userConnections: { connections } } = getState();
  const filteredConnections = connections.filter(elem => elem.id !== id);
  dispatch({ type: SET_CONNECTION, connections: filteredConnections });
};

export const getHasPendingRequests = () => (dispatch) => {
  apiFetch('GET', { endPoint: 'users/has_pending_requests' })
    .then((response) => {
      dispatch({ type: SET_HAS_PENDING_REQUESTS, hasPendingRequests: response.has_pending_requests });
    });
};

let timerPendingRequests = null;
export const getHasPendingRequestsWithTimer = () => (dispatch) => {
  if (timerPendingRequests !== null) {
    clearTimeout(timerPendingRequests);
  }

  timerPendingRequests = setTimeout(() => {
    timerPendingRequests = null;
    dispatch(getHasPendingRequests());
  }, 10000);
};

const INITIAL_STATE = {
  connections: [],
  requested: [],
  recommendations: [],
  hasPendingRequests: false,
};

const handleModalNotifications = (state, notification) => {
  switch (notification.req_message) {
    case NOTIFICATIONS.NEW_USER_CONNECTION: {
      const user = JSON.parse(notification.user);
      user.match_actions = 'connect';
      user.match_actual_user_actions = 'connect';
      const newConnections = [...state.connections];
      newConnections.push(user);
      return {
        ...state,
        connections: newConnections,
      };
    }
    case NOTIFICATIONS.HAS_PENDING_REQUESTS: {
      const hasPendingRequests = parseInt(notification.has_pending_requests, 10) > 0;
      return {
        ...state,
        hasPendingRequests,
      };
    }
    default:
      return state;
  }
};

const ACTION_HANDLERS = {
  [NOTIFICATION]: (state, action) => (handleModalNotifications(state, action.payload)),
  [NOTIFICATION_TO_ROOM]: (state, action) => (handleModalNotifications(state, action.payload)),
  [SET_CONNECTION]: (state, action) => ({
    ...state,
    connections: action.connections,
  }),
  [SET_HAS_PENDING_REQUESTS]: (state, action) => ({
    ...state,
    hasPendingRequests: action.hasPendingRequests,
  }),
  [SET_RECOMMENDATIONS]: (state, action) => ({
    ...state,
    recommendations: action.recommendations,
  }),
  [SET_CONNECTIONS_REQUESTED]: (state, action) => ({
    ...state,
    requested: action.requested,
  }),
  [ADD_REQUESTED_CONNECTION]: (state, action) => ({
    ...state,
    requested: [...state.requested, action.user],
  }),
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/store/globalState/reducers/userConnections.js